<template>
  <div class="scrollable" v-loading.fullscreen.lock="fullscreenLoading">
    <v-header></v-header>
    <div class="content">
      <div class="breadNav">
        <p>
          体检服务 >
          预约{{ $t("m.staffPhyAckOrder.brankNav2") }}
        </p>
      </div>
      <div class="user">
        <p class="icon"></p>
        <p class="name">
          {{ $t("m.medicalReports.phyPerson") }}：{{ showMsg.name }}（{{
            showMsg.relationship_value
          }}）
        </p>
        <p class="sex">{{ showMsg.gender_value }}</p>
        <p class="idCard">
          {{ $t("m.phyOrderDetails.cardNum") }}：{{ showMsg.identity_code }}
        </p>
        <p class="idCard">出生日期:{{ showMsg.birthday }}</p>
        <p class="phone" v-if="showMsg.contacttel != ''">
          {{ $t("m.phyOrderDetails.phone") }}：{{ showMsg.contacttel }}
        </p>
        <!-- <p class="revise">修改</p> -->
      </div>
      <div class="hospitalTime">
        <div class="tit">
          <!-- <p class="icon"></p> -->
          <!-- <p>{{ $t("m.staffMsg.hosTime") }}：</p> -->
        </div>
        <div class="hospital">
          <p>体检城市：
          <p class="city">{{ getConfirm.confirmMsg.cityNameCheck }}</p></p>

        </div>
        <div class="hospital">
          <p>体检分院：
          <p class="city">{{ getConfirm.confirmMsg.brandsName }}</p></p>
          <p class="jg ">{{ getConfirm.confirmMsg.hosNameCheck }}
          <p style="color:#FF000F;margin-left:10px;font-size: 14px;" @click="getHosMsg">
            查看分院详情
          </p>
        </div>
        <div class="addressMsg" style="font-size: 16px;">{{ getConfirm.confirmMsg.addressMsg }}</div>
        <div class="time" style="margin-bottom: 20px;">
          <p>{{ $t("m.phyOrderDetails.time") }}：</p>
          <p>{{ getConfirm.paramsJSON.exam_date }}</p>
        </div>
        <div style="width: 98%;height: 1px;background: #ccc;margin: 5px 0; "></div>
        <div class="time" style="position:relative;">
          <p> {{ $t("m.staffMsg.mealList") }}：</p>
          <p style="font-size: 18px;color: #333;font-weight: 600;margin-left: 33px;">
            {{ getConfirm.confirmMsg.phyNameCheck }}
            <span class="comboDetail" @click="getPhyMsg">{{
                $t("m.phyOrderDetails.getMealDetail")
              }}</span>
          </p>
          <div style="position: absolute;right: 20px;font-size: 18px;font-weight: normal;">
            ￥{{ getConfirm.limitMsg.payment_detail.exam_package.price }}
          </div>
        </div>

        <div
          class="hospital"
          id="package"
          v-if="
            getConfirm.paramsJSON.add_packages != undefined &&
            getConfirm.paramsJSON.add_packages.length > 0
          "
          style="position: relative;"
        >
          <p>腰椎颈椎2选1：</p>
          <div id="jxService">
            <div
              class="city"
              :key="index"
              v-for="(item, index) in getConfirm.limitMsg.payment_detail.extra_packages"
              style="margin-left:-55px"
            >{{ item.name }}
              <div style="position: absolute;right: 20px;margin-top: -18px;font-weight: normal;">￥{{ item.price }}</div>
            </div>

          </div>

        </div>
        <div
          class="hospital"
          id="addtion"
          v-if="
            getConfirm.paramsJSON.self_paid_packages != undefined &&
            getConfirm.paramsJSON.self_paid_packages.length > 0
          "
          style="position: relative;margin-bottom: 30px;"
        >
          <p>加项包：</p>
          <div id="jxService">
            <div
              class="city"
              :key="index" style="margin:0px 0 20px 0;"
              v-for="(item, index) in getConfirm.limitMsg.payment_detail.self_paid_packages"
            >{{ item.name }}
              <div style="position: absolute;right: 20px;margin-top: -18px;font-weight: normal;">￥{{ item.price }}</div>
            </div>
          </div>
        </div>
        <div style="width: 98%;height: 1px;background: #ccc;margin: 30px 0; "></div>
        <div class="hospital" style="position: relative;">
          <p>实际支付金额:</p>
          <div style="position: absolute;right: 20px;margin-top: -20px;color: #FF000F;font-size: 18px;">
            ￥{{ getConfirm.limitMsg.sett_price }}
          </div>
        </div>
      </div>


      <div class="hospitalTime" v-if="getConfirm.paramsJSON.receiver_address">
        <div class="tit">
          <p class="icon"></p>
          <p>{{ $t("m.staffPhyAckOrder.consigneeTit") }}：</p>
        </div>
        <div class="hospital">
          <p>{{ $t("m.staffPhyAckOrder.consigneeName") }}：</p>
          <p class="city">{{ getConfirm.paramsJSON.receiver_address.name }}</p>
        </div>
        <div class="hospital">
          <p>{{ $t("m.staffPhyAckOrder.consigneePhone") }}：</p>
          <p class="city">
            {{ getConfirm.paramsJSON.receiver_address.mobile }}
          </p>
        </div>
        <div class="hospital">
          <p>{{ $t("m.staffPhyAckOrder.consigneeAddress") }}：</p>
          <p class="city">
            {{ getConfirm.paramsJSON.receiver_address.full_address }}
          </p>
        </div>
        <div style="width: 98%;height: 1px;background: #ccc;margin:20px 0; "></div>
      </div>

      <div
        class="reportTit"
        v-if="
          $route.query.isShowReport === true ||
          $route.query.type === 'dependents'
        "
      >
        <div>
          <p class="icon"></p>
          <p class="name">尊敬的客户，您好！</p>
        </div>
        <p class="xq">
          因体检报告为个人隐私，本平台暂无法提供家属体检报告查询功能。
        </p>
        <p class="xq">
          您可在体检结束后，关注该体检机构发送的体检报告出具通知，按操作获取并查看，感谢您的理解与支持！
        </p>
      </div>
      <!-- 授权 -->
      <div class="user" v-if="phyPersonType=='staff' &&  authorization==1 && report_type==0 && branch_type==0"
           style="position: relative;">
        <i class="icon"></i>
        <p class="name">已授权-检后7-10个工作日在线查看电子报告</p>
      </div>
      <div class="user1" v-if="phyPersonType=='staff' && authorization==0 && report_type==0 && branch_type==0">
        <!-- <i class="icon"></i> -->
        <p class="name">未授权 - 前台咨询获取纸质报告或 - <span @click="cxauthorization" style="color:#FF000F">重新授权</span></p>
        <div class="ts" 
             style="font-size: 16px;"><span style="color:#FF000F">*提示：</span>您当前未授权则不能在本平台查询报告，并无法享受报告解读服务；<br/><span
          style="padding-left:42px ;">（如选择同意授权，体检报告数据将严格保密，不会产生个人信息暴露）</span></div>
      </div>
      <div class="user" v-if="phyPersonType=='staff' && (report_type!=0 || (report_type==0 && branch_type==1))">
        <i class="icon"></i>
        <p class="name">该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询</p>
      </div>
      <div class="wxts">
        <p class="p1">
          温馨提示:
        </p>
        <p class="p2">1. 由于各体检中心、医院因设备及检验方式的不同，体检套餐中个别项目门店会根据情况略有调整，具体请以体检中心为准。<br>
          2. 因疫情防控部署，部分体检项目（如：耳鼻喉、口腔、肺功能、幽门螺旋杆菌等）有可能暂停检查，具体请以各体检中心情况为准。<br>
          <!-- <span  v-if="getConfirm.confirmMsg.cityNameCheck=='厦门市'||getConfirm.confirmMsg.cityNameCheck=='汕头市'||getConfirm.confirmMsg.cityNameCheck=='江门市'||getConfirm.confirmMsg.cityNameCheck=='中山市'||getConfirm.confirmMsg.cityNameCheck=='广州市'||getConfirm.confirmMsg.cityNameCheck=='重庆市'">3. 同档位套餐公立医院比民营机构体检项目少；民营体检机构名额充足，服务环境良好，获取报告速度快，建议您优先选择民营体检机构进行体检。</span> -->
        </p>
      </div>

      <div class="integral" style="margin-top: 20px">
        <div class="left">
          <!-- <p v-if="getConfirm.confirmMsg.limit!=0 && $route.query.type=='dependents'">提示：您已超出免费预约次数，需自费</p> -->
        </div>
        <div class="right">
          <!-- <p class="jxNum">已选择<span>1</span>件加项包</p> -->
          <!-- <p class="price">
            {{ $t("m.common.total") }}：
            <span>￥{{ getConfirm.confirmMsg.limit | number }}</span>
          </p> -->
          <p
            class="submit"
            @click="submit"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            确认并提交
          </p>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <!-- 查看套餐详情 -->
    <div id="interpret">
      <el-dialog
        :visible.sync="combointerpretVisible"
        :close-on-click-modal="false"
      >
        <div
          v-if="comboDetailLoading"
          style="width: 100%; display: flex; justify-content: center"
        >
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!comboDetailLoading" class="interpretMsg">
          <div class="mealName">
            <p class="icon"></p>
            <p class="name">
              {{ $t("m.staffMsg.mealList") }}：{{ datajson.name }}
              {{ datajson.description }}
            </p>
            <p class="msg">
              {{
                $t("m.staffMealDetail.mealNum1")
              }}{{
                datajson.check_item_count
              }}{{
                $t("m.staffMealDetail.mealNum2")
              }}{{ $t("m.staffMealDetail.mealNum3") }}
            </p>
          </div>
          <p
            style="
              font-size: 14px;
              line-height: 26px;
              margin-top: 20px;
              color: #FF000F;
            "
          >
            温馨提示：由于各体检中心/医院设备及检验方式不同，体检套餐中个别项目会略有调整，具体请以体检中心/医院为准。
          </p>
          <div
            class="details"
            :key="index"
            v-for="(item, index) in datajson.items"
          >
            <div class="tit">
              <p>{{ item.name }}</p>
            </div>
            <el-table :data="item.items" border stripe style="width: 100%">
              <el-table-column
                prop="name"
                :label="$t('m.staffMealDetail.medicalItems')"
              ></el-table-column>
              <el-table-column
                prop="clinic_mean"
                :label="$t('m.staffMealDetail.examinationSignificance')"
              ></el-table-column>
              <el-table-column
                prop="content"
                :label="$t('m.staffMealDetail.checkItems')"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('combo')">{{
              $t("m.common.closeBtn")
            }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看分院详情弹窗 -->
    <div id="interpret">
      <el-dialog :visible.sync="interpretVisible" :close-on-click-modal="false">
        <div
          v-if="hosDetailLoading"
          style="width: 100%; display: flex; justify-content: center"
        >
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!hosDetailLoading" class="interpretMsg">
          <div class="hospitalName">
            <p class="icon"></p>
            <p class="name">
              {{ $t("m.staffHosDetail.hos") }}：{{ datajson.name }}
            </p>
          </div>
          <div class="map" id="XSDFXPage"></div>
          <div class="mapMsg">
            <p>
              <span>{{ $t("m.staffHosDetail.address") }} :</span>
              <span>{{ datajson.address }}</span>
            </p>
            <p>
              <span>{{ $t("m.staffHosDetail.time") }} :</span>
              <span>{{ datajson.work_time }}</span>
            </p>
            <!-- <p><span>{{$t('m.staffHosDetail.phone')}} : </span><span>{{datajson.inst_contact}} </span></p> -->
            <!-- <p>
              <span>{{$t('m.staffHosDetail.msg')}} :</span>
              <span>{{datajson.description}}</span>
            </p>
            <p>
              <span>{{$t('m.staffHosDetail.line')}} :</span>
              <span>{{datajson.traffic_route}}</span>
            </p> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('hos')">{{
              $t("m.common.closeBtn")
            }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 授权报告 -->
    <el-dialog :visible.sync="reportVisible" :close-on-click-modal="false" style="border-radius: 20px;">
      <div class="reportMsg">
        <p style="font-size:33px;margin-bottom: 10px;font: bold;text-align: center;color: #333333;">体检报告授权协议</p>
        <p style="color: #333;font-size: 18px;">亲爱的用户，您好！</p>
        <p style="color: #333;font-size: 18px;">请查看并阅读<a
          style="color: #e51e26;cursor: pointer;text-decoration: underline;" target="1"
          href="../../../../static/pdf/用户授权协议.pdf">《体检报告授权协议》</a>，确定是否同意在本平台查看体检报告。</p>
        <p style="font-size:16px;color:#333;">注：</p>
        <p style="font-size: 16px;color: #333;line-height: 25px;">
          1.连锁私立体检机构（爱康/美年/瑞慈）默认为电子报告，您授权后即可在本平台查看并使用报告解读等服务；</p>
        <p style="font-size: 16px;color: #333;margin: 5px 0;line-height: 25px;">
          2.和谐健康等其他民营机构的报告，需由各机构指定的方式获取。您获取后，在电脑端上传个人体检报告，方能在本平台查询报告以及使用报告解读等服务。</p>
        <p style="font-size: 16px;color: #333;line-height: 25px;">
          3.公立医院为纸质报告，需自取或团检统一返还，并由您在电脑端上传个人体检报告以后，方能使用报告解读以及健康评估等服务。</p>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="reportVisible=false">取消</el-button>
      <el-button type="primary" @click="agreeBtn">{{
          $t("m.common.define")
        }}</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
    import axios from "axios";
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import header from "../../common/header.vue";
    import footer from "../../common/footer.vue";
    import {
        login
    } from "../../../utils/api";

    export default {
        name: "phyAckOrder",
        data() {
            return {
                checked: false,
                getConfirm: {},
                fullscreenLoading: false,
                showMsg: {},
                interpretVisible: false, //分院弹窗是否显示
                datajson: {},
                combointerpretVisible: false, //套餐详情弹窗是否显示
                project: {},
                isFirstEnter: false, // 定义变量来判断是否第一次进入，默认false
                dialogVisible: false,
                show: true,
                isMobile: false,
                counts: "",
                timer: null,
                fullscreenLoading: false,
                hosDetailLoading: false,
                comboDetailLoading: false,
                btnLoading: false,
                authorization: null,
                phyPersonType: null,
                institutionType: null,
                reportVisible: false,
                getlimitMsg: {},
                report_type: null,
                branch_type: null,
                details: {},
            };
        },
        components: {
            "v-header": header,
            "v-footer": footer,
        },
        created() {
            let _this = this;
            _this.isFirstEnter = true;
            _this.project = JSON.parse(sessionStorage.getItem("project"));
            _this.getConfirm = JSON.parse(sessionStorage.getItem("staffParams"));
            _this.getlimitMsg = JSON.parse(sessionStorage.getItem("limitMsg"));
            _this.authorization = sessionStorage.getItem("authorization");
            _this.report_type = JSON.parse(
                sessionStorage.getItem("staffParams")
            ).confirmMsg.report_type;
            _this.branch_type = JSON.parse(
                sessionStorage.getItem("staffParams")
            ).confirmMsg.branch_type;
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "SuccessfulAppointment") {
                // 这个name是下一级页面的路由name
                to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
            }
            next();
        },
        activated() {
            let _this = this;
            // if (location.href.split('?')[1].split('&')[0].split('=')[1] == 'staff') {
            //     _this.phyPersonType = 'staff'
            // } else {
            //     _this.phyPersonType = 'dependents'
            // }
            _this.phyPersonType = sessionStorage.getItem("type");
            _this.authorization = sessionStorage.getItem("authorization");
            _this.institutionType = sessionStorage.getItem("institutionType");
            if (!_this.$route.meta.isBack || _this.isFirstEnter) {
                _this.checked = false;
                _this.getConfirm = {};
                _this.fullscreenLoading = false;
                _this.showMsg = {};
                _this.interpretVisible = false;
                _this.datajson = {};
                _this.combointerpretVisible = false;
                _this.project = {};
                _this.getPhysical();
                _this.project = JSON.parse(sessionStorage.getItem("project"));
                _this.getConfirm = JSON.parse(sessionStorage.getItem("staffParams"));
                _this.report_type = JSON.parse(
                    sessionStorage.getItem("staffParams")
                ).confirmMsg.report_type;
                _this.branch_type = JSON.parse(
                    sessionStorage.getItem("staffParams")
                ).confirmMsg.branch_type;
                // _this.getlimitMsg = JSON.parse(sessionStorage.getItem("limitMsg"))
            }
            // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
            _this.$route.meta.isBack = false;
            // // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
            _this.isFirstEnter = false;
        },
        filters: {
            number(value) {
                var toFixedNum = Number(value).toFixed(3);
                var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
                return realVal;
            },
        },
        mounted() {},
        methods: {
            ...mapActions(["message"]),
            //获取体检人列表
            getPhysical() {
                let _this = this;
                _this.fullscreenLoading = true;
                axios
                    .get(BASE_URL + "/exam/relatives/")
                    .then((res) => {
                        _this.fullscreenLoading = false;
                        res.data.data.forEach(function(element) {
                            if (element.id == _this.getConfirm.paramsJSON.relative) {
                                _this.showMsg = element;
                            }
                        });
                    })
                    .catch((err) => {
                        _this.fullscreenLoading = false;
                    });
            },
            // 授权
            cxauthorization() {
                this.reportVisible = true;
                // this.authorization = 1
                // sessionStorage.setItem('authorization', 1)
            },
            //不同意授权
            disAgreeBtn() {
                this.reportVisible = false;
                this.authorization = 0;
                sessionStorage.setItem("authorization", 0);
            },
            //同意授权
            agreeBtn() {
                this.reportVisible = false;
                this.authorization = 1;
                sessionStorage.setItem("authorization", 1);
            },
            //关闭按钮
            closeBtn(type) {
                let _this = this;
                if (type == "combo") {
                    _this.combointerpretVisible = false;
                } else {
                    _this.interpretVisible = false;
                }
            },
            //加项的查看详情
            getAddMsg(index, name) {
                let _this = this;
                _this.$alert(
                    _this.getConfirm.confirmMsg.additionNameMsgCheck[index],
                    name, {
                        confirmButtonText: _this.$t("m.common.define"),
                        callback: (action) => {},
                    }
                );
            },
            //查看套餐详情
            getPhyMsg() {
                let _this = this;
                _this.datajson = {};
                _this.combointerpretVisible = true;
                _this.comboDetailLoading = true;
                let exam_type;
                if (_this.$route.query.type == "staff") {
                    exam_type = "";
                } else {
                    exam_type = "&exam_type=relative";
                }
                //获取套餐详情接口
                axios
                    .get(
                        BASE_URL +
                        "/exam/hospitals/" +
                        _this.getConfirm.paramsJSON.hospital +
                        "/combos/" +
                        _this.getConfirm.paramsJSON.combo +
                        "/" +
                        "?project=" +
                        _this.project.id +
                        exam_type
                    )
                    .then((res) => {
                        _this.comboDetailLoading = false;
                        _this.datajson = res.data.data;
                    })
                    .catch((err) => {
                        _this.comboDetailLoading = false;
                    });
            },
            //查看机构详情
            getHosMsg() {
                let _this = this;
                _this.datajson = {};
                _this.interpretVisible = true;
                _this.hosDetailLoading = true;
                //获取机构详情接口
                axios
                    .get(
                        BASE_URL +
                        "/exam/hospitals/" +
                        _this.getConfirm.paramsJSON.hospital +
                        "/", {
                            params: {
                                project: _this.project.id,
                            },
                        }
                    )
                    .then((res) => {
                        _this.hosDetailLoading = false;
                        _this.datajson = res.data.data;
                        setTimeout(function() {
                            _this.setMap();
                        }, 100);
                    })
                    .catch((err) => {
                        _this.hosDetailLoading = false;
                    });
            },
            // 地图
            setMap() {
                let _this = this;
                //创建Map实例
                var map = new BMap.Map("XSDFXPage");
                // 初始化地图,设置中心点坐标
                var point = new BMap.Point(
                    parseFloat(_this.datajson.longitude),
                    parseFloat(_this.datajson.latitude)
                ); // 创建点坐标
                map.centerAndZoom(point, 15);
                //添加鼠标滚动缩放
                map.enableScrollWheelZoom();

                //添加缩略图控件
                map.addControl(
                    new BMap.OverviewMapControl({
                        isOpen: false,
                        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                    })
                );
                //添加缩放平移控件
                map.addControl(new BMap.NavigationControl());
                //添加比例尺控件
                map.addControl(new BMap.ScaleControl());
                //添加地图类型控件
                //map.addControl(new BMap.MapTypeControl());

                //设置标注的图标
                var icon = new BMap.Icon(
                    require("../../../assets/icon.png"),
                    new BMap.Size(100, 100)
                );
                //设置标注的经纬度
                var marker = new BMap.Marker(
                    new BMap.Point(
                        parseFloat(_this.datajson.longitude),
                        parseFloat(_this.datajson.latitude)
                    ), {
                        icon: icon,
                    }
                );
                //把标注添加到地图上
                map.addOverlay(marker);
                var content = "<table>";
                // content = content + "<tr><td> 编号：001</td></tr>";
                content = content + "<tr><td> " + _this.datajson.name + "</td></tr>";
                // content = content + "<tr><td> 时间：2018-1-3</td></tr>";
                content += "</table>";
                var infowindow = new BMap.InfoWindow(content);
                marker.addEventListener("click", function() {
                    _this.openInfoWindow(infowindow);
                });

                //点击地图，获取经纬度坐标
                // map.addEventListener("click",function(e){
                //      document.getElementById("aa").innerHTML = "经度坐标："+e.point.lng+" &nbsp;纬度坐标："+e.point.lat;
                //  });
            },
            //确认预约
            submit() {
                let _this = this;
                _this.finsSubmit();
            },
            //提交接口
            finsSubmit() {
                let _this = this;
                _this.fullscreenLoading = true;
                let params = _this.getConfirm.paramsJSON;
                params.health_risk_appraisal = _this.checked;
                if (sessionStorage.getItem("val") == 1421) {
                    params.pay_success_url = `${window.location.origin}/#/middlePageTeeth`;
                } else {
                    params.pay_success_url = `${window.location.origin}/#/middlePage?type=${this.$route.query.type}`;
                }
                params.pay_fail_url = `${window.location.origin}/#/errorAppointment?type=${this.$route.query.type}`;
                // params.index_url = pdf_URL + "/#/phyExServices";
                params.report_authorize = Number(sessionStorage.getItem("authorization"));

                //预约接口
                axios
                    .post(BASE_URL + "/exam/orders/", params)
                    .then((res) => {
                        // console.log(res);
                        _this.fullscreenLoading = false;
                        if (res.status == 200) {
                            if (res.data.data.pay_gateway_url) {
                                window.location.href = res.data.data.pay_gateway_url;
                            } else {
                                if (sessionStorage.getItem("val") == 1421) {
                                    _this.$router.push({
                                        path: "/middlePageTeeth",
                                    });
                                } else {
                                    _this.$router.push({
                                        path: "/middlePage",
                                        query: {
                                            type: _this.$route.query.type,
                                            order_no: res.data.data.order_no,
                                        },
                                    });
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        _this.fullscreenLoading = false;
                    });
            },
        },
        computed: {
            // ...mapGetters(['allUserMsg']) // 动态计算属性，相当于this.$store.getters.resturantName
        },
    };
</script>

<style scoped>
    .reportTit {
        width: 1180px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        padding-left: 30px;
    }
    
    .reportTit div {
        display: flex;
        width: 1180px;
        margin: 30px 0 12px 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    
    .reportTit .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .reportTit .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .reportTit .xq {
        font-size: 18px;
        font-weight: 400;
        color: #ff000f;
        line-height: 30px;
    }
    
    .reportTit .xq:nth-child(3) {
        margin-bottom: 25px;
    }
    
    .getcode {
        width: 92px;
        height: 30px;
        background: #999999;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        line-height: 16px;
        margin-right: 10px;
        cursor: pointer;
    }
    
    .editMsg {
        width: 100%;
    }
    
    .editMsg .item {
        width: 100%;
        height: 50px;
        border: 1px solid #dfdfdf;
        border-radius: 4px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    
    .editMsg .item p:first-child {
        width: 120px;
        text-align: center;
        /*padding: 17px 20px;*/
        font-size: 16px;
        font-weight: 400;
        color: #999;
        line-height: 16px;
    }
    
    .editMsg .item p:last-child {
        height: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #999;
        line-height: 16px;
        display: flex;
        align-items: center;
        border-left: 1px solid #dfdfdf;
        padding-left: 20px;
    }
    
    .editMsg .item input {
        width: 60%;
        height: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
        display: flex;
        align-items: center;
        border-left: 1px solid #dfdfdf;
        padding-left: 20px;
    }
    
    .editMsg .item .radioDiv {
        width: 60%;
        height: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
        display: flex;
        align-items: center;
        border-left: 1px solid #dfdfdf;
        padding-left: 20px;
    }
    
    .hospitalName {
        width: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    
    .hospitalName .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .hospitalName .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .mapMsg {
        width: 100%;
        margin: 0 auto;
        margin-top: 30px;
    }
    
    .mapMsg p span:first-child {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 26px;
    }
    
    .mapMsg p span:last-child {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 26px;
    }
    
    .map {
        width: 100%;
        height: 260px;
        border: 1px solid #ccc;
        margin: 0 auto;
        margin-top: 30px;
        padding: 20px;
    }
    
    .map img {
        width: 100%;
        height: 100%;
    }
    
    .details {
        width: 100%;
        margin: 0 auto;
    }
    
    .details .tit {
        width: 100%;
        height: 46px;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        /* background: rgba(255, 240, 230, 1); */
        background: #ffeeef;
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    
    .details .tit p {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        line-height: 16px;
    }
    
    .mealName {
        width: 100%;
        height: 78px;
        border: 1px solid #ccc;
        margin: 0 auto;
        /*margin-top: 30px;*/
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 30px;
    }
    
    .mealName .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .mealName .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .mealName .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        margin-left: 10px;
    }
    
    .package .tit .name {
        font-size: 18px;
        font-weight: normal;
        color: #333;
        line-height: 18px;
        font-weight: bold;
        margin-left: 7px;
    }
    
    .note {
        font-size: 18px;
        font-weight: normal;
        color: #ff000f !important;
        line-height: 18px;
        font-weight: 400 !important;
    }
    
    .comboDetail {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        /* text-decoration: underline; */
        cursor: pointer;
    }
    
    #package,
    #addtion {
        display: flex;
        align-items: flex-start;
        height: auto;
    }
    
    #jxService {
        display: flex;
        flex-direction: column;
        margin-left: 50px;
        /*align-items: center;*/
    }
    
    #jxService span:nth-child(1) {
        margin-top: 0;
    }
    
    #jxService span {
        display: inline-block;
        margin-top: 20px;
    }
    
    .jxprice {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        padding-left: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .integral {
        width: 1180px;
        height: 46px;
        /* background: rgba(242, 242, 242, 1); */
        margin: 0 auto;
        margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        padding-left: 30px;
        align-items: center;
    }
    
    .integral .left p {
        font-size: 14px;
        font-weight: 400;
        color: #ff6633;
        line-height: 14px;
    }
    
    .integral .right {
        display: flex;
        align-items: center;
    }
    
    .integral .right .jxNum {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 14px;
    }
    
    .integral .right .jxNum span {
        color: #e51e26;
    }
    
    .integral .right .price {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 14px;
        margin-left: 30px;
    }
    
    .integral .right .price span {
        color: #ff000f;
        font-size: 16px;
        line-height: 16px;
    }
    
    .integral .right .submit {
        width: 220px;
        height: 46px;
        background: #ff000f;
        display: flex;
        border-radius: 30px;
        align-items: center;
        justify-content: center;
        margin-left: 50px;
        font-size: 20px;
        /*font-weight:600;*/
        color: #fff;
        line-height: 20px;
        cursor: pointer;
    }
    
    .assess {
        width: 1180px;
        height: 18px;
        margin: 0 auto;
        padding: 29px 30px;
        display: flex;
        align-items: center;
    }
    
    .tc {
        width: 1180px;
        border: 1px solid #ccc;
        margin: 0 auto;
        padding: 30px;
        display: flex;
        margin-top: 30px;
        align-items: center;
    }
    
    .tc .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .tc .name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .tc .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
    }
    
    .hospitalTime .time p:last-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 30px;
    }
    
    .hospitalTime .addressMsg {
        display: flex;
        margin-left: 150px;
        margin-top: 20px;
    }
    
    .hospitalTime .addressMsg .msg {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        text-decoration: underline;
        margin-left: 10px;
        cursor: pointer;
    }
    
    .hospitalTime .addressMsg .address {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
    }
    
    .hospitalTime .addressMsg .address span {
        color: #ff000f;
    }
    
    .hospitalTime .addressMsg .address span:last-child {
        padding-left: 10px;
        color: #666;
    }
    
    .hospitalTime .hospital .city,
    .hospitalTime .hospital .jg {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 33px;
    }
    
    .hospitalTime .hospital p:first-child,
    .hospitalTime .time p:first-child {
        /* width: 220px; */
        font-size: 18px;
        font-weight: 400;
        color: #333;
        line-height: 18px;
        display: flex;
        justify-content: flex-end;
        margin-left: 30px;
    }
    
    .hospitalTime .hospital,
    .hospitalTime .time {
        width: 100%;
        /*height: 18px;*/
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    
    .hospitalTime {
        width: 1180px;
        margin: 0 auto;
        border: 1px solid #ccc;
        padding: 30px;
        margin-top: 30px;
    }
    
    .hospitalTime .tit {
        display: flex;
        align-items: center;
    }
    
    .hospitalTime .tit .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .hospitalTime .tit p:last-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .user {
        width: 1180px;
        height: 78px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding-left: 30px;
    }
    
    .user .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .user .name,
    .user .sex,
    .user .idCard,
    .user .phone {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
    }
    
    .user .name {
        margin-left: 7px;
    }
    
    .user .sex {
        margin-left: 20px;
    }
    
    .user .idCard {
        margin-left: 20px;
    }
    
    .user .phone {
        margin-left: 20px;
    }
    
    .user .revise {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        margin-left: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .user1 {
        width: 1180px;
        height: 144px;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 30px;
        position: relative;
        /* display: flex; */
        /* align-items: center; */
        padding-left: 30px;
    }
    
    .user1 .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .user1 .name,
    .user1 .sex,
    .user1 .idCard,
    .user1 .phone {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: absolute;
        top: 31px;
        left: 30px;
        line-height: 18px;
    }
    
    .user1 .name {
        margin-left: 7px;
    }
    
    .user1 .sex {
        margin-left: 20px;
    }
    
    .user1 .idCard {
        margin-left: 20px;
    }
    
    .user1 .phone {
        margin-left: 20px;
    }
    
    .user1 .revise {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 16px;
        margin-left: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .user1 .ts {
        position: absolute;
        left: 30px;
        line-height: 30px;
        top: 60px;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
    
    .wxts {
        width: 1180px;
        margin: 0 auto;
        margin-top: 30px;
        border: solid 1px #ccc;
        /* height: 152px; */
        padding-bottom: 30px;
    }
    
    .p1 {
        margin: 30px 0 10px 30px;
        font-size: 18px;
        color: #333;
        font-weight: 600;
    }
    
    .p2 {
        margin-left: 30px;
        font-size: 18px;
        color: #333;
        line-height: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/phyAckOrder.vue